import { SET_DURING_RESTORING, SET_ENVIRONMENTS, SET_CONNECTED_ENVIRONMENTS, RUN_ENVIRONMENT, SET_DETAILS, SET_CONNECTED_ENV_DETAILS, SET_SNAPSHOTS, SNACKBAR, ERROR_SNACKBAR, SET_SHARED_WITH, SET_APPLICATION_PROVIDERS, SET_ENVIRONMENT_SSH_KEYS, SET_ENVIRONMENT_STATUS, SET_SNAPSHOT_STATUS } from '../mutation-types';
import ApiService from '../../services/api.service';
import asyncWrapper from '../../utils/asyncWrapper';

const state = {
  environments: [],
  connectedEnvironments: [],
  details: [],
  connectedEnvironmentDetails: [],
  snapshots: [],
  sharedEnvironmentWith: [],
  environmentSSHKeys: [],
  duringRestoring: false
}

const getters = {
  environments: state => {
    return state.environments;
  },
  connectedEnvironments: state => {
    return state.connectedEnvironments;
  },
  details: state => {
    return state.details
  },
  connectedEnvironmentDetails: state => {
    return state.connectedEnvironmentDetails
  },
  snapshots: state => {
    return state.snapshots
  },
  sharedEnvironmentWith: state => {
    return state.sharedEnvironmentWith
  },
  environmentSSHKeys: state => {
    return state.environmentSSHKeys;
  },
  duringRestoring: state => {
    return state.duringRestoring;
  }
}

const actions = {
  async getEnvironments({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('environments'));
    // console.log('environments', result);
    !error ? commit(SET_ENVIRONMENTS, result) : commit(ERROR_SNACKBAR, 'Unable to get environments');
  },
  async getConnectedEnvironments({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('environments/connected'));

    !error ? commit(SET_CONNECTED_ENVIRONMENTS, result) : commit(ERROR_SNACKBAR, 'Unable to get connected environments');
    // console.log(result);
  },
  async runEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/create', data));

    !error ? commit(SNACKBAR, 'Environment will be created soon!') : commit(ERROR_SNACKBAR, error.response.data.error);

    return { error, result };
  },
  async runConnectedEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/create', data));

    !error ? commit(SNACKBAR, 'Environment will be created soon!') : commit(ERROR_SNACKBAR, error.response.data.error);

    return { error, result };
  },
  async stopEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/stop', data));

    !error ? commit(SNACKBAR, 'Environment will be stopped soon!') : commit(ERROR_SNACKBAR, 'Unable to stop environment');
  },
  async startEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/start', data));

    !error ? commit(SNACKBAR, 'Environment will be started soon!') : commit(ERROR_SNACKBAR, 'Unable to start environment');
  },
  async stopConnectedEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/stop', data));

    !error ? commit(SNACKBAR, 'Environment will be stopped soon!') : commit(ERROR_SNACKBAR, 'Unable to stop environment');
  },
  async startConnectedEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/start', data));

    !error ? commit(SNACKBAR, 'Environment will be started soon!') : commit(ERROR_SNACKBAR, 'Unable to start environment');
  },
  async deleteEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/delete', data));

    !error ? commit(SNACKBAR, 'Environment will be deleted soon!') : commit(ERROR_SNACKBAR, 'Unable to delete environment');
  },
  async deleteConnectedEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/delete', data));

    !error ? commit(SNACKBAR, 'Environment will be deleted soon!') : commit(ERROR_SNACKBAR, 'Unable to delete environment');
  },
  async shareEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/share', data));

    !error ? commit(SNACKBAR, 'Environment successfully shared!') : commit(ERROR_SNACKBAR, 'Unable to share environment');
  },
  async shareConnectedEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/share', data));

    !error ? commit(SNACKBAR, 'Environment successfully shared!') : commit(ERROR_SNACKBAR, 'Unable to share environment');
  },
  async stopSharingEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/stopshare', data));

    !error ? commit(SNACKBAR, 'Sharing stopped') : commit(ERROR_SNACKBAR, 'Stop sharing failed');
  },
  async stopSharingConnectedEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/stopshare', data));

    !error ? commit(SNACKBAR, 'Sharing stopped') : commit(ERROR_SNACKBAR, 'Stop sharing failed');
  },
  async getDetails({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`environments/details/${id}`));

    !error ? commit(SET_DETAILS, result) : commit(ERROR_SNACKBAR, 'Unable to get environment');

    return { error, result }
  },
  async getConnectedEnvironmentDetails({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`environments/connected/details/${id}`));

    !error ? commit(SET_CONNECTED_ENV_DETAILS, result) : commit(ERROR_SNACKBAR, 'Unable to get environment');

    return { error, result }
  },
  async reshareEnvironment({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.put('environments/accesslevel', data));

    if (error) {
      commit(ERROR_SNACKBAR, 'Failed during access level update');
    }
  },
  async updateConnectedEnvAccessLevel({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.put('environments/connected/accesslevel', data));

    if (error) {
      commit(ERROR_SNACKBAR, 'Failed during access level update');
    }
  },
  async getSharedEnvironmentWith({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`environments/sharedWith/${id}`));

    !error ? commit(SET_SHARED_WITH, result) : commit(ERROR_SNACKBAR, 'Unable to get shared users');
  },
  async updateEnvironmentName({ commit, dispatch }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/update/name', data));

    if (!error) {
      commit(SNACKBAR, 'Environment name has been updated successfully!')
      await dispatch('getDetails', data.environmentId)
      return { error, result }
    } else {
      commit(ERROR_SNACKBAR, error.response.data.error);
      return { error, result }
    }
  },
  async updateConnectedEnvironmentName({ commit, dispatch }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('environments/connected/update/name', data));

    if (!error) {
      commit(SNACKBAR, 'Environment name has been updated successfully!')
      await dispatch('getConnectedEnvironmentDetails', data.environmentId)
      return { error, result }
    } else {
      commit(ERROR_SNACKBAR, error.response.data.error);
      return { error, result }
    }
  },
  async modifyScheduler({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.put(`environments/scheduler/modify`, data));
    !error ? commit(SNACKBAR, 'Scheduler settings successfully changed') : commit(ERROR_SNACKBAR, 'Error during modify scheduler settings');
  },
  async modifyConnectedEnvironmentScheduler({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.put(`environments/connected/scheduler/modify`, data));
    !error ? commit(SNACKBAR, 'Scheduler settings successfully changed') : commit(ERROR_SNACKBAR, 'Error during modify scheduler settings');
  },
  async getWhitelistedIPs({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`vm/${id}/ips`));

    if (error) {
      commit(ERROR_SNACKBAR, 'Cannot get whitelisted IP addresses');
    }

    return result;
  },
  async deleteWhitelistedIP({ commit }, { id, CidrIp }) {
    const { error, result } = await asyncWrapper(ApiService.delete(`vm/${id}/ips?CidrIp=${CidrIp}`));

    if (error) {
      commit(ERROR_SNACKBAR, 'Cannot delete whitelisted IP address.');
    }

    return { error, result };
  },
  async addWhitelistedIP({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.post(`vm/${id}/ips`));

    if (error) {
      commit(ERROR_SNACKBAR, 'Cannot add whitelisted IP address.');
    }

    return { error, result };
  },
  async getEnvironmentSSHKeys({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.get(`vm/ssh/${data}`));

    !error ? commit(SET_ENVIRONMENT_SSH_KEYS, result) : commit(ERROR_SNACKBAR, 'Unable to get environment ssh keys');
  },
  async associateKeyWithEnvironment({ commit, dispatch }, data) {
    const { error, result } = await asyncWrapper(ApiService.post(`vm/ssh/associate`, data));

    if (!error) {
      await dispatch('getEnvironmentSSHKeys', data.environmentId)
      commit(SNACKBAR, "Key was successfully associated with environment");
    }
    else
      commit(ERROR_SNACKBAR, 'Unable to asscociate key with environment');
  },
  async disassociateKeyFromEnvironment({ commit, dispatch }, data) {
    const { error, result } = await asyncWrapper(ApiService.post(`vm/ssh/disassociate`, data));

    if (!error) {
      await dispatch('getEnvironmentSSHKeys', data.environmentId)
      commit(SNACKBAR, "Key was successfully disassociated from environment");
    }
    else
      commit(ERROR_SNACKBAR, 'Unable to disassociate key from environment');
  },
  async getSnapshots({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`vm/${id}/snapshots`));

    !error ? commit(SET_SNAPSHOTS, result) : commit(ERROR_SNACKBAR, 'Could not get snapshots!')
  },
  async getConnectedSnapshots({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`vm/connected/${id}/snapshots`));

    !error ? commit(SET_SNAPSHOTS, result) : commit(ERROR_SNACKBAR, 'Could not get snapshots!')
  },
  async deleteSnapshot({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.delete(`vm/${id}/snapshot`));

    console.log({
      error,
      result
    });

    if (error) {
      commit(ERROR_SNACKBAR, 'Could not delete snapshot!');
    }

    return { error, result }
  },
  async createTemplate({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('vm/templates/create', data));
    console.log(error)
    !error ? commit(SNACKBAR, "Template will be created soon") : commit(ERROR_SNACKBAR, error.response.data.error);
  },
  async restoreSnapshot({ commit }, id) {
    commit(SET_DURING_RESTORING, true);

    const { error, result } = await asyncWrapper(ApiService.put(`vm/${id}/snapshot`));

    commit(SET_DURING_RESTORING, false);

    console.log({
      error,
      result
    });

    if (error) {
      commit(ERROR_SNACKBAR, 'Snapshot could not be restored!');
    } else {
      commit(SNACKBAR, 'Snapshot will be restored soon!')
      commit(SET_ENVIRONMENT_STATUS, 'DURING_RESTORE')
    }

    return { error, result }
  },
  async restoreConnectedSnapshot({ commit }, { id, connectedEnvId }) {
    commit(SET_DURING_RESTORING, true);

    const { error, result } = await asyncWrapper(ApiService.put(`vm/connected/${id}/snapshot`, { connectedEnvId }));

    commit(SET_DURING_RESTORING, false);

    console.log({
      error,
      result
    });

    if (error) {
      commit(ERROR_SNACKBAR, 'Snapshot could not be restored!');
    } else {
      commit(SNACKBAR, 'Snapshot will be restored soon!')
      commit(SET_ENVIRONMENT_STATUS, 'DURING_RESTORE')
    }

    return { error, result }
  },
  createTemplateFromSnapshot({ commit }, id) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('create template from snapshot', id);
        commit(SNACKBAR, 'Template from snapshot has been created!');
        resolve();
      }, 1);
    });
  },
  async createSnapshot({ commit }, { id, ...snapshot } = data) {
    const { error, result } = await asyncWrapper(ApiService.post(`vm/${id}/snapshot`, snapshot));

    if (!error) {
      commit(SNACKBAR, 'Snapshot will be created soon!')
      commit(SET_SNAPSHOT_STATUS, 'pending')
    } else {
      commit(ERROR_SNACKBAR, error.response.data.error);
    }

    return { error, result };
  },
  async createConnectedSnapshot({ commit }, { id, ...snapshot } = data) {
    const { error, result } = await asyncWrapper(ApiService.post(`vm/connected/${id}/snapshot`, snapshot));

    if (!error) {
      commit(SNACKBAR, 'Snapshot will be created soon!')
      commit(SET_SNAPSHOT_STATUS, 'pending')
    } else {
      commit(ERROR_SNACKBAR, error.response.data.error);
    }

    return { error, result };
  }
}

const mutations = {
  [SET_ENVIRONMENTS](state, payload) {
    state.environments = payload;
  },
  [SET_CONNECTED_ENVIRONMENTS](state, payload) {
    state.connectedEnvironments = payload;
  },
  [SET_DETAILS](state, payload) {
    state.details = payload;
  },
  [SET_CONNECTED_ENV_DETAILS](state, payload) {
    state.connectedEnvironmentDetails = payload;
  },
  [SET_SNAPSHOTS](state, payload) {
    state.snapshots = payload;
  },
  [SET_SHARED_WITH](state, payload) {
    state.sharedEnvironmentWith = payload;
  },
  [SET_ENVIRONMENT_SSH_KEYS](state, payload) {
    state.environmentSSHKeys = payload;
  },
  [SET_ENVIRONMENT_STATUS](state, payload) {
    state.details.Status = payload
  },
  [SET_SNAPSHOT_STATUS](state, payload) {
    state.details.SnapshotStatus = payload
  },
  [SET_DURING_RESTORING](state, payload) {
    state.duringRestoring = payload;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
